module.exports = __webpack_public_path__ + "media/application/images/svgs/blob-4-234fe99e546a2bdc790303a0e2230438.svg";